

var MediaManager = function()
{

	/**
	 * [manager description]
	 * @type {[type]}
	 */
	var manager = this;

	/**
	 * [modal description]
	 * @type {[type]}
	 */
	var modalObj = null;

	/**
	 * [progressObj description]
	 * @type {[type]}
	 */
	var progressObj = null;

	/**
	 * [uploadButton description]
	 * @type {[type]}
	 */
	var uploadButton = null;

	/**
	 * [MAX_FILE_SIZE description]
	 * @type {Number}
	 */
	var MAX_FILE_SIZE = 300000000;

	/**
	 * [permitted description]
	 * @type {Array}
	 */
	var permitted = [
		'image/svg+xml',
		'image/jpeg',
		'image/gif',
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		'image/png',
		'application/pdf',
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
	];

	/**
	 * [form description]
	 * @type {[type]}
	 */
	var form = null;

	/**
	 * [token description]
	 * @type {[type]}
	 */
	var token = null;

	/**
	 * [displayDate description]
	 * @type {[type]}
	 */
	var displayDate = null;

	/**
	 * [FILE_TYPE_ERROR description]
	 * @type {String}
	 */
	var FILE_TYPE_ERROR = 'The file type is not permitted.';

	/**
	 * [MAX_FILE_SIZE_ERROR description]
	 * @type {String}
	 */
	var MAX_FILE_SIZE_ERROR = 'The files size is too large.';

	/**
	 * [receiver description]
	 * @type {Boolean}
	 */
	this.receiver = false;

	/**
	 * [jqInput description]
	 * @type {Boolean}
	 */
	this.jqInput = false;

	/**
	 * [restrict description]
	 * @type {String}
	 */
	this.restrict = '';

	/**
	 * [select description]
	 * @param  {[type]} selector [description]
	 * @param  {[type]} el       [description]
	 * @return {[type]}          [description]
	 */
	var select = function( selector, el ) {
		if ( ! el ) { el = document; }
		return Array.prototype.slice.call( el.querySelectorAll( selector ) );
	};

	/**
	 * [getAttributes description]
	 * @param  {[type]} node [description]
	 * @return {[type]}      [description]
	 */
	var getAttributes = function( node )
	{
		var attributes = {};
		for( var i in node.attributes ) {
			if( node.attributes.hasOwnProperty( i ) ) {
				attributes[node.attributes[i].name] = node.attributes[i].nodeValue;
			}
		}
		return attributes;
	};



	/**
	 * [done description]
	 * @return {Function} [description]
	 */
	var done = function(){
		$('[data-src]').each(function(){
			var that = $(this);
			var tmpImage = new Image;
			tmpImage.src = $(this).attr( 'data-src' );
			tmpImage.onload = function(){
				that.attr( 'src', that.attr( 'data-src' ) );
				that.removeAttr('data-src');
			};
		});
		$('.receiver .selectable').unbind('click').bind('click', function(e){
			var selected = $(this);
			var evn = $.Event( "selected", {
				mediaID : selected.attr('data-media-id'),
				basename : selected.attr('data-media-basename')
			});
			manager.active.trigger(evn);
			modalObj.modal('hide');
		});
	};

	/**
	 * [activeEdit description]
	 * @type {[type]}
	 */
	var activeEdit = null;

	/**
	 * [MediaAttachment description]
	 * @param {[type]} $input [description]
	 */
	var MediaAttachment = function( $input )
	{

		/**
		 * [ma description]
		 * @type {[type]}
		 */
		var ma = this;

		/**
		 * [input description]
		 * @type {[type]}
		 */
		this.input = $input;

		/**
		 * [selectButton description]
		 * @type {[type]}
		 */
		this.selectButton = null;

		/**
		 * [removeButton description]
		 * @type {[type]}
		 */
		this.removeButton = null;

		/**
		 * [placeholder description]
		 * @type {[type]}
		 */
		this.placeholder = null;

		/**
		 * [inputName description]
		 * @type {[type]}
		 */
		this.inputName = null;

		/**
		 * [image description]
		 * @type {[type]}
		 */
		this.image = null;

		/**
		 * [multiple description]
		 * @type {Boolean}
		 */
		this.multiple = false;

		/**
		 * [values description]
		 * @type {Array}
		 */
		this.values = [];

		/**
		 * [addNewCard description]
		 */
		this.addNewCard = function()
		{
			var card = $('<div />')
				.addClass('card')
				.appendTo( ma.placeholder );

			ma.image = $('<img />')
				.attr( 'width', 300 )
				.attr( 'height', 300 )
				.attr( 'src', '/package/purposemedia/admin-media-manager/images/white-image.png' )
				.appendTo( card );

			var buttons = $('<div />')
				.addClass('ui buttons')
				.appendTo( card );

			ma.selectButton = $('<button />')
				.html('<i class="ui picture icon" /> Attach Image')
				.addClass('ui purple button')
				.appendTo( buttons );

			ma.removeButton = $('<button />')
				.html('<i class="ui trash icon" /> Remove')
				.addClass('ui red button')
				.appendTo( buttons );



		};

		/**
		 * [createMultipleImageSelectPlaceholder description]
		 * @return {[type]} [description]
		 */
		this.createMultipleImageSelectPlaceholder = function()
		{


		};

		/**
		 * [createSingleImageSelectPlaceholder description]
		 * @return {[type]} [description]
		 */
		this.createSingleImageSelectPlaceholder = function()
		{
			ma.placeholder = $('<div />').addClass('card receiver single-image-receiver');

			ma.image = $('<img />')
				.attr( 'width', 300 )
				.attr( 'height', 300 )
				.attr( 'src', '/package/purposemedia/admin-media-manager/images/white-image.png' )
				.appendTo( ma.placeholder );

			if( parseInt( ma.input.val() ) !== 0 && parseInt( ma.input.val() ) !== NaN ) {
				$.get( '/admin/media-manager/get/' + ma.input.val(), function( model ){
					ma.image.attr('src', '/admin/media-manager/alter-image/crop/300/300/' + model.name + '.' + model.extension );
				});
			}

			var buttons = $('<div />')
				.addClass('ui buttons')
				.appendTo( ma.placeholder );

			ma.selectButton = $('<button />')
				.html('<i class="ui picture icon" /> Attach Image')
				.addClass('ui purple button')
				.appendTo( buttons );

			ma.removeButton = $('<button />')
				.html('<i class="ui trash icon" /> Remove')
				.addClass('ui red button')
				.appendTo( buttons );

			ma.placeholder.insertAfter( ma.input );

		};

		/**
		 * [generatePlaceholder description]
		 * @return {[type]} [description]
		 */
		this.generatePlaceholder = function()
		{
			switch( ma.input.attr( 'data-media-type' ) ) {
				case 'images' :
					if( ma.input.attr( 'data-media-multiple' ) && ma.input.attr( 'data-media-multiple' ) === 'true' ) {
						ma.multiple = true;
						ma.createMultipleImageSelectPlaceholder();
					} else {
						ma.createSingleImageSelectPlaceholder();
					}
				break;
			}
		};

		/**
		 * [received description]
		 * @return {[type]} [description]
		 */
		this.received = function(e)
		{
			console.log(e);
			ma.image.attr( 'src', '/admin/media-manager/alter-image/crop/300/300/' + e.basename );
			ma.input.val( e.mediaID );
			if( ma.multiple ) {
				ma.addNewCard();
			}
		};

		/**
		 * [onSelectButtonClick description]
		 * @return {[type]} [description]
		 */
		this.onSelectButtonClick = function(e)
		{
			manager.active = ma.input;
			mediaManager.open(e, this);
		};

		/**
		 * [onRemoveButtonClick description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		this.onRemoveButtonClick = function(e)
		{
			e.preventDefault();
			manager.active = null;
			ma.image.attr( 'src', '/package/purposemedia/admin-media-manager/images/white-image.png' );
			ma.input.val('0');
		};

		/**
		 * [events description]
		 * @return {[type]} [description]
		 */
		this.events = function()
		{
			ma.input.bind( 'selected', ma.received );
			ma.selectButton.bind( 'click', ma.onSelectButtonClick );
			ma.removeButton.bind( 'click', ma.onRemoveButtonClick );
		};

		/**
		 * [init description]
		 * @return {[type]} [description]
		 */
		this.init = function()
		{
			ma.generatePlaceholder();
			ma.events();
			ma.input.hide();
		};

		try {
			ma.init();
		} catch( e ) {
			console.log(e.message);
		}

	};

	/**
	 * [removeImage description]
	 * @param  {[type]} e      [description]
	 * @param  {[type]} button [description]
	 * @return {[type]}        [description]
	 */
	this.removeImage = function( e, button )
	{
		e.preventDefault();
		var wrapper = $(button).parent();
		var input = wrapper.prev();
		var img = $('img', wrapper);
		input.val(0);
		img.attr('src', '/package/purposemedia/admin-media-manager/images/white-image.png');
	};

	/**
	 * [message description]
	 * @param  {[type]} message [description]
	 * @return {[type]}         [description]
	 */
	this.uploadError = function( message )
	{
		progressObj.progress({ percent : 0 });
		progressObj.hide();
		uploadButton.value = '';
		var container = $('[data-for="message"]');
		container.text('').append( $('<div class="ui small red message" />').text( message ) );
		setTimeout( function(){
			container.text('');
		}, 3000 );
	};

	/**
	 * [open description]
	 * @return {[type]} [description]
	 */
	this.open = function( event, _button )
	{
		manager.restrict = '';
		button = false;
		if( typeof event === 'object' && typeof _button === 'object' ) {
			event.preventDefault();
			button = _button;
		}
		$('body').toggleClass('ui form loading');
		manager.loadMainView( button );
	};

	/**
	 * [loadMainView description]
	 * @return {[type]} [description]
	 */
	this.loadMainView = function( _button )
	{
		modalObj.removeClass('receiver');
		$( '.upload.actions', modalObj ).slideDown(0);
		$( '.alt.actions', modalObj ).slideUp(0);
		if( _button ) {
			modalObj.addClass('receiver');
			if( $(_button).attr('data-restrict') ) {
				manager.restrict = $(_button).attr('data-restrict');
			}
		}
		modalObj.modal('show');
		$('body').toggleClass('ui form loading');
		manager.refresh( false, false, function() {
			setTimeout(function(){
				modalObj.modal('refresh');
			}, 100 );
		});
	};

	/**
	 * [refresh description]
	 * @param  {[type]}   year     [description]
	 * @param  {[type]}   month    [description]
	 * @param  {Function} callback [description]
	 * @return {[type]}            [description]
	 */
	this.refresh = function( year, month, callback )
	{
		$('> .content', modalObj).addClass('ui form loading');
		callback = callback || function(){};
		var itemsContainer = $('[data-for="items"]');
		if( ! year && ! month ) {
			$.get( '/admin/media-manager/refresh/?restrict=' + manager.restrict, function( response ){
				itemsContainer.html('');
				response.items.forEach( function( item ){
					var itemBlock = manager.createItemBlock( item );
					itemBlock.appendTo( itemsContainer );
				});
				manager.createTree( response.structure );
				displayDate.html('Displaying from ' + response.current_month + ', ' + response.current_year );
				$('> .content', modalObj).removeClass('ui form loading');
				callback();
				done();
			});
		} else {
			$.get( '/admin/media-manager/refresh/' + year + '/' + month + '?restrict=' + manager.restrict, function( response ){
				itemsContainer.html('');
				response.items.forEach( function( item ){
					var itemBlock = manager.createItemBlock( item );
					itemBlock.appendTo( itemsContainer );
				});
				manager.createTree( response.structure );
				$('> .content', modalObj).removeClass('ui form loading');
				callback();
				done();
			});
		}
	};

	/**
	 * [createTree description]
	 * @param  {[type]} structure [description]
	 * @return {[type]}           [description]
	 */
	this.createTree = function( structure )
	{
		if( structure.length === 0 ) return;
		var structureContainer = $('[data-for="structure"]');
		var tree = $('<div class="ui vertical menu"></div>');
		for( var i in structure ) {
			var year = i;
			var months = structure[i];
			var yearNode = $('<div class="ui simple dropdown item"> ' + year + ' <i class="dropdown icon"></i></div>');
			var monthsNode = $('<div class="menu"></div>');
			months.forEach(function(month){
				var monthName = $('<a />').attr('href', 'javascript:window.mediaManager.refresh("' + year + '","' + month + '")').addClass('item').text(month);
				monthName.appendTo( monthsNode );
			});
			monthsNode.appendTo( yearNode );
			yearNode.appendTo( tree );
		}
		structureContainer.html('');
		tree.appendTo( structureContainer );

	};

	/**
	 * [saveAltText description]
	 * @param  {[type]} mediaID [description]
	 * @return {[type]}         [description]
	 */
	this.saveAltText = function()
	{
		$( '.upload.actions', modalObj ).slideDown(200);
		$( '.alt.actions', modalObj ).slideUp(200);
		var text = $('[data-for="alt-text"]').val();
		$.post('/admin/media-manager/save-alt/' + activeEdit, { text : text, _token : token }, function(){

		});
	};

	/**
	 * [closeEditBox description]
	 * @param  {[type]} mediaID [description]
	 * @return {[type]}         [description]
	 */
	this.closeEditBox = function()
	{
		$( '.upload.actions', modalObj ).slideDown(200);
		$( '.alt.actions', modalObj ).slideUp(200);
	};

	/**
	 * [showEditAlt description]
	 * @param  {[type]} mediaID [description]
	 * @return {[type]}         [description]
	 */
	this.showEditAlt = function( mediaID )
	{
		$( '.upload.actions', modalObj ).slideUp(200);
		$( '.alt.actions', modalObj ).slideDown(200);
		activeEdit = mediaID;
		var textBox = $('[data-for="alt-text"]');
		$.get('/admin/media-manager/get-media-info/' + mediaID, function( model ){
			textBox.val( model.alt_text );
		});
	};

	/**
	 * [delete description]
	 * @param  {[type]} route [description]
	 * @return {[type]}       [description]
	 */
	this.delete = function( route )
	{
		$.get( route, function( mediaID ){
			$('[data-id="' + mediaID + '"]').fadeOut( 200, function(){
				$(this).remove();
			});
		});
	};

	/**
	 * [createItemBlock description]
	 * @param  {[type]} item [description]
	 * @return {[type]}      [description]
	 */
	this.createItemBlock = function( item )
	{
		var tmpl = $('#item-block-tmpl').html();
		tmpl = tmpl.replace( /{% media-id %}/g, item.id );
		tmpl = tmpl.replace( '{% size %}', item.size );
		tmpl = tmpl.replace( '{% name %}', item.name );
		tmpl = tmpl.replace( '{% basename %}', item.name + '.' + item.extension );
		if( ! item.clear_cache ) {
			tmpl = tmpl.replace( '{% image-src %}', '/admin/media-manager/alter-image/crop/165/85/' + item.name + '.' + item.extension );
		} else {
			tmpl = tmpl.replace( '{% image-src %}', '/admin/media-manager/alter-image/crop/165/85/' + item.name + '.' + item.extension + '?cc=' + Math.random().toString(36).substring(7) );
		}
		tmpl = tmpl.replace( '{% date %}', item.date );
		tmpl = tmpl.replace( '{% delete-route %}', item.delete_route );
		return $(tmpl);
	};

	/**
	 * [init description]
	 * @return {[type]} [description]
	 */
	this.init = function()
	{
		form = document.getElementById( 'media-manager-upload-form' );
		/** only initialize if the form is available */
		if( form ) {
			uploadButton = document.getElementById('media-manager-file-upload');
			token = $('.actions input[name="_token"]').val();
			modalObj = $('#media-manager-modal').modal();
			progressObj = $('#media-upload-progress-bar').progress('increment');
			displayDate = $('[data-for="display-date"]');
			manager.events();
		}
	};

	/**
	 * [events description]
	 * @return {[type]} [description]
	 */
	this.events = function()
	{
		uploadButton.removeEventListener( "change", manager.uploadHandeler );
		uploadButton.addEventListener( "change", manager.uploadHandeler, false );
		$('[data-for="filtering-media"]').keyup( function(e){
			e.preventDefault();
			var query = $(this).val();
			$('[data-media-basename]').each(function(){
				var name = $(this).attr('data-media-basename');
				$(this).parent().hide();
				if( name.toLowerCase().match( query.toLowerCase() ) ) {
					$(this).parent().show();
				}
			});
		});
		$('[data-for="media-attachment"]').each(function(){
			new MediaAttachment( $(this) );
		});
	};

	/**
	 * [uploadHandeler description]
	 * @param  {[type]} e [description]
	 * @return {[type]}   [description]
	 */
	this.uploadHandeler = function(e)
	{
		progressObj.show();
		var files = e.target.files || e.dataTransfer.files;
		for ( var i = 0, file; file = files[i]; i++ ) {
			manager.uploadFile( file );
		}

	};

	/**
	 * [uploadFile description]
	 * @param  {[type]} file [description]
	 * @return {[type]}      [description]
	 */
	this.uploadFile = function( file )
	{

		var xhr = new XMLHttpRequest();


		if ( xhr.upload ) {

			if( file.size >= MAX_FILE_SIZE ) {
				return manager.uploadError( MAX_FILE_SIZE_ERROR );
			}

			if( ! $.inArray( file.type, permitted ) ) {
				return manager.uploadError( FILE_TYPE_ERROR );
			}

			// progress bar
			xhr.upload.addEventListener( "progress", function(e) {
				var pc = parseInt((e.loaded / e.total * 100));
				progressObj.progress({
					percent : pc
				});
			}, false);

			// file received/failed
			xhr.onreadystatechange = function(e) {
				if ( xhr.readyState == 4 ) {
					progressObj.progress({
						percent : 0
					});
					progressObj.hide();
					uploadButton.value = '';
					if( xhr.status !== 200 ) {
						alert('failed');
					} else {
						manager.refresh( false, false, function() {
							setTimeout(function(){
								modalObj.modal('refresh');
							}, 100 );
						});
					}
				}
			};

			// start upload
			xhr.open("POST", form.action, true);
			xhr.setRequestHeader('X-CSRF-TOKEN', token);
			xhr.setRequestHeader("X-FILENAME", file.name );
			xhr.send(file);

		} else {
			progressObj.progress({
				percent : 0
			});
			progressObj.hide();
			uploadButton.value = '';
			alert("File forbidden or too large");
		}
	}

};

jQuery(document).ready( function($){

	window.mediaManager = new MediaManager();
	window.mediaManager.init();

});